export enum GallerySize {
    Large = 'Large',
    Medium = 'Medium',
    Small = 'Small',
    Mini = 'Mini'
}